<template>
  <div>
    <div v-if="step == 0">
      <SelectMedicineID :showMedicine="false" v-on:selected="selected" />
      <ErrorsMessages :errors="errors" />
    </div>
    <div v-if="step == 1">
      <div class="row">
        <div class="col-md-12">
          <label>NOME COMERCIAL</label>
          <input
            :disabled="medicine"
            v-model="name"
            type="text"
            class="form-control"
          />
        </div>
        <div class="col-md-12">
          <SelectActiveIngredientID
            :disabled="medicine ? true : false"
            refautofocus
            v-model="active_ingredient_id"
          />
        </div>
        <div class="col-md-6">
          <label>UNIDADE DE MEDIDA</label>
          <select
            @change="handleChangeUnitOfMeasurementId($event.target.value)"
            :disabled="medicine"
            v-model="unit_of_measurement_id"
            class="form-control"
          >
            <option value="">SELECIONE...</option>
            <option
              v-for="value in unitOfMeasurements"
              :key="value.id"
              :value="value.id"
              :ref="`unit_of_measurement_${value.id}`"
              :data-name="value.name"
              :data-v="value.value"
              :data-abbreviation="value.abbreviation"
            >
              {{ value.name }}
            </option>
          </select>
        </div>
        <div class="col-md-6">
          <label>UNIDADE DE ADMINISTRAÇÃO</label>
          <input
            disabled
            v-model="unit_of_measurement_abbreviation"
            type="text"
            class="form-control"
          />
        </div>
        <div class="col-md-6">
          <label>TIPO DE RECEITA</label>
          <select
            :disabled="medicine"
            v-model="type_of_recipe_id"
            class="form-control"
          >
            <option value="">SELECIONE...</option>
            <option
              v-for="value in typesOfRecipe"
              :key="value.id"
              :value="value.id"
            >
              {{ value.name }}
            </option>
          </select>
        </div>
        <div class="col-md-12">
          <ErrorsMessages :errors="errors" />
        </div>
      </div>
    </div>
    <div v-if="step == 2">
      <div class="row">
        <div
          class="
            col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12
            pt-0
            pb-0
            d-flex
            align-items-center
          "
        >
          <img
            :src="require('../../../../assets/capsules-solid.svg')"
            width="40"
            class="mb-2"
          />
          <div class="ml-2">
            <h6 class="mb-0">
              MEDICAMENTO:
              {{ name }}
            </h6>
            <h6 class="mb-0">
              UNIDADE DE MEDIDA:
              {{ unit_of_measurement_name }}
            </h6>
            <h6 class="mb-0">
              UNIDADE DE ADMINISTRAÇÃO:
              {{ unit_of_measurement_abbreviation }}
            </h6>
          </div>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 pt-0 pb-0">
          <LabelRequiredField label="GRUPO" />
          <select v-model="stock_group_id" class="form-control">
            <option value="">SELECIONE...</option>
            <option
              v-for="stock in stock_groups"
              :key="stock.id"
              :value="stock.id"
            >
              {{ stock.name }}
            </option>
          </select>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 pt-0 pb-0">
          <LabelRequiredField :label="unit_of_measurement_name" />
          <input v-model="amount" type="number" class="form-control" />
        </div>
        <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 pt-0 pb-0">
          <LabelRequiredField label="LOTE" />
          <input v-model="lot" type="text" class="form-control" />
        </div>
        <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 pt-0 pb-0">
          <LabelRequiredField label="DATA DE VENCIMENTO" />
          <input v-model="due_date" type="month" class="form-control" />
        </div>
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0 pb-0">
          <label>DESCRIÇÃO</label>
          <ChromeSpeechToTextTextarea
            rows="2"
            max-rows="2"
            v-model="description"
          />
        </div>
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0 pb-0">
          <ErrorsMessages :errors="errors" />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 d-flex justify-content-between">
        <v-btn :disabled="step == 0" @click="handlePrevStep" class="btn-return"
          ><i class="fas fa-arrow-left mr-2 text-twenty"></i>
          {{ step == 1 ? "ESCOLHER MEDICAMENTO" : "VOLTAR" }}</v-btn
        >
        <v-btn :disabled="loading" @click="handleNextStep" class="btn-save"
          ><i
            :class="[
              'mr-2 text-twenty',
              'fa',
              step == 2 ? 'fa-save' : 'fa-arrow-right',
            ]"
          ></i>
          {{
            step == 2 ? (loading ? "CARREGANDO" : "FINALIZAR") : "AVANÇAR"
          }}</v-btn
        >
      </div>
    </div>
  </div>
</template>

<script>
import SelectMedicineID from "../../../Components/SelectMedicineID";

import SelectActiveIngredientID from "../../../Components/SelectActiveIngredientID";

import ErrorsMessages from "../../../Components/ErrorsMessages";

import LabelRequiredField from "../../../Components/LabelRequiredField";

import ChromeSpeechToTextTextarea from "../../../Components/ChromeSpeechToTextTextarea";

import api from "../../../../services/api";

import APIGet from "../../../../lib/api-get";

import toast from "../../../../lib/ToastNotification";

export default {
  name: "NewMedicine",

  components: {
    SelectMedicineID,
    SelectActiveIngredientID,
    ErrorsMessages,
    LabelRequiredField,
    ChromeSpeechToTextTextarea,
  },

  props: {
    resident_id: [String, Number],
  },

  data() {
    return {
      step: 0,
      medicine: true,
      stock_group_id: "",
      unit_of_measurement_id: "",
      name: "",
      active_ingredient_id: "",
      type_of_recipe_id: "",
      unit_of_measurement_name: "",
      unit_of_measurement_value: "",
      unit_of_measurement_abbreviation: "",
      due_date: "",
      lot: "",
      amount: "",
      description: "",

      unitOfMeasurements: [],
      typesOfRecipe: [],
      stock_groups: [],
      categories: [],

      errors: [],
      loading: false,
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    handlePrevStep() {
      const { step } = this;

      this.errors = [];

      if (step == 0) {
        return;
      }

      this.step = step - 1;
    },

    handleNextStep() {
      this.errors = [];

      let { step } = this;

      if (step == 0) {
        this.step = step + 1;
      }

      if (step == 1) {
        let { name, active_ingredient_id, unit_of_measurement_id } = this;

        if (!String(name).trim()) {
          this.errors.push({
            id: this.errors.length,
            message: "Informe o nome comercial",
          });
        }

        if (!String(active_ingredient_id).trim()) {
          this.errors.push({
            id: this.errors.length,
            message: "Informe o princípio ativo",
          });
        }

        if (!String(unit_of_measurement_id).trim()) {
          this.errors.push({
            id: this.errors.length,
            message: "Informe a unidade de medida",
          });
        }

        if (this.errors.length > 0) {
          return;
        }

        this.step = step + 1;
      }

      if (step == 2) {
        this.execute();
        return;
      }
    },

    selected(medicine) {
      this.errors = [];

      if (medicine.id) {
        let {
          name,
          active_ingredient_id,
          unit_of_measurement_id,
          unit_of_measurement_name,
          unit_of_measurement_value,
          unit_of_measurement_abbreviation,
          type_of_recipe_id,
        } = medicine;

        this.medicine = medicine;
        this.name = name;
        this.active_ingredient_id = active_ingredient_id;
        this.unit_of_measurement_id = unit_of_measurement_id;
        this.unit_of_measurement_name = unit_of_measurement_name;
        this.unit_of_measurement_value = unit_of_measurement_value;
        this.unit_of_measurement_abbreviation =
          unit_of_measurement_abbreviation;
        this.type_of_recipe_id = type_of_recipe_id;
      } else {
        this.medicine = null;
        this.name = medicine;
        this.active_ingredient_id = "";
        this.unit_of_measurement_id = "";
        this.unit_of_measurement_name = "";
        this.unit_of_measurement_value = "";
        this.unit_of_measurement_abbreviation = "";
        this.type_of_recipe_id = "";
      }

      this.step = 1;
    },

    handleChangeUnitOfMeasurementId(value) {
      this.unit_of_measurement_abbreviation = "";

      if (value) {
        let { name, v, abbreviation } =
          this.$refs[`unit_of_measurement_${value}`][0].dataset;

        this.unit_of_measurement_name = name;
        this.unit_of_measurement_value = v;
        this.unit_of_measurement_abbreviation = abbreviation;
      }
    },

    async retrieve() {
      if (this.errors.length == 0) {
        await this.getUnitOfMeasurements();
        await this.getStockGroups();
        await this.getTypesOfRecipe();
      }
    },

    async getUnitOfMeasurements() {
      try {
        const response = await api.get("/rest-home/unit-of-measurement/all");

        const { error, errors, unit_of_measurement } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.unitOfMeasurements = unit_of_measurement;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async getStockGroups() {
      this.loading = true;
      let params = { type: "MEDICINE" };
      const { error, errors, stock_groups } = await APIGet.getStockGroups(
        params
      );
      this.errors = errors;
      this.stock_groups = error ? [] : stock_groups;
      this.loading = false;
    },

    async getTypesOfRecipe() {
      try {
        const response = await api.get("/rest-home/type-of-recipe/all");

        const { error, errors, types } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.typesOfRecipe = types;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async execute() {
      try {
        this.loading = true;

        let {
          resident_id,
          stock_group_id,
          medicine,
          name,
          type_of_recipe_id,
          active_ingredient_id,
          unit_of_measurement_id,
          unit_of_measurement_value,
          lot,
          amount,
          due_date,
          description,
        } = this;

        let params = {
          resident_id,
          stock_group_id,
          medicine,
          name,
          type_of_recipe_id,
          active_ingredient_id,
          unit_of_measurement_id,
          unit_of_measurement_value,
          lot,
          amount,
          due_date,
          description,
          from: "NEW_MEDICINE",
        };

        const response = await api.post(
          "/rest-home/resident/stock/medicine-entry",
          params
        );

        const { error, errors, message } = response.data;

        if (!error) {
          toast(message, "success");
          this.$emit("success");
          this.$bvModal.hide("createMedicine");
          this.errors = [];
        } else {
          this.errors = errors;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
